// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---gatsby-theme-antv-site-pages-404-tsx": function componentGatsbyThemeAntvSitePages404Tsx() {
    return import("./../../../gatsby-theme-antv/site/pages/404.tsx"
    /* webpackChunkName: "component---gatsby-theme-antv-site-pages-404-tsx" */
    );
  },
  "component---gatsby-theme-antv-site-pages-index-tsx": function componentGatsbyThemeAntvSitePagesIndexTsx() {
    return import("./../../../gatsby-theme-antv/site/pages/index.tsx"
    /* webpackChunkName: "component---gatsby-theme-antv-site-pages-index-tsx" */
    );
  },
  "component---gatsby-theme-antv-site-templates-apis-tsx": function componentGatsbyThemeAntvSiteTemplatesApisTsx() {
    return import("./../../../gatsby-theme-antv/site/templates/apis.tsx"
    /* webpackChunkName: "component---gatsby-theme-antv-site-templates-apis-tsx" */
    );
  },
  "component---gatsby-theme-antv-site-templates-document-tsx": function componentGatsbyThemeAntvSiteTemplatesDocumentTsx() {
    return import("./../../../gatsby-theme-antv/site/templates/document.tsx"
    /* webpackChunkName: "component---gatsby-theme-antv-site-templates-document-tsx" */
    );
  },
  "component---site-pages-independent-en-tsx": function componentSitePagesIndependentEnTsx() {
    return import("./../../site/pages/independent.en.tsx"
    /* webpackChunkName: "component---site-pages-independent-en-tsx" */
    );
  },
  "component---site-pages-independent-zh-tsx": function componentSitePagesIndependentZhTsx() {
    return import("./../../site/pages/independent.zh.tsx"
    /* webpackChunkName: "component---site-pages-independent-zh-tsx" */
    );
  },
  "component---site-pages-index-en-tsx": function componentSitePagesIndexEnTsx() {
    return import("./../../site/pages/index.en.tsx"
    /* webpackChunkName: "component---site-pages-index-en-tsx" */
    );
  },
  "component---site-pages-index-zh-tsx": function componentSitePagesIndexZhTsx() {
    return import("./../../site/pages/index.zh.tsx"
    /* webpackChunkName: "component---site-pages-index-zh-tsx" */
    );
  }
};